import { useDispatch, useSelector } from "react-redux"

import { addNumberOfMonths, formatCurrency, formatDate, formatDateLocal, isCaseType, isDateTodayOrInThePast } from "../../../../lib/script"
import DefaultUpdater from "../../../common/DefaultUpdater"
import SelfPayItemPracticeV2 from "./SelfPayItemPracticeV2"
import FindRelatedChusaPatient from "./FindRelatedChusaPatient"
import ChusaRelatedPatient from "./ChusaRelatedPatient"
import { majorMedExistsAndIsValid, numberOfPaymentsExceedsTheSettings, totalBalanceExceedsTheSettings } from "../../../../lib/verifications"
import SimpleBoxDisplay from "../../../common/SimpleBoxDisplay"
import { caseActions } from "../../../../store/case"
import { notificationActions } from "../../../../store/notifications"
import { caseQuickUpdate } from "../../../../lib/fetchApi"
import InputBox from "../../../common/interactive/InputBox"
import InputBoxCurrency from "../../../common/interactive/InputBoxCurrency"
import DatepickerWithLabel from "../../../common/interactive/DatepickerWithLabel"

import ItemSimpleV2 from "../Shared/ItemSimpleV2"
import classes from '../Shared/ItemV2.module.css'
import classesv3 from '../Shared/ItemV3.module.css'
import { frontendOptions } from "../../../../lib/systemData"


const SelfPayItem = ({itemData, apiCase}) => {
    const dispatch = useDispatch() 
    const activeCase = useSelector(state => state.case.activeCase) 
    const userToken = useSelector(state => state.user.token)

    const updateHandler = async (data) => {
        let reqBody = {
            type: data.identifier.type,
            fields: {
                [data.identifier.field] : data.data.value,
            }
        }
            
        let dispatchObj = {
            folder: data.identifier.folder,
            item: {
                fields: [
                    {
                        field: data.identifier.field,
                        value: data.data.value
                    },
                ]            
            }
        }

        function setEndDate(start, months) {
            let endDate = formatDate(addNumberOfMonths(start, months))
            reqBody.fields.end_date = endDate
            dispatchObj.item.fields.push({
                field: 'end_date',
                value: endDate
            })
        }

        if (data.identifier.field == 'no_payments') { // calculate month payment
            if (itemData.total_balance) {
                let monthlyPayment = itemData.total_balance / data.data.value
                reqBody.fields.monthly_payment = monthlyPayment?.toFixed(2)
                reqBody.fields.has_approved = null
                reqBody.fields.has_payment_plan_created = null

                let dArr = [
                    {
                        field: 'monthly_payment',
                        value: monthlyPayment?.toFixed(2)
                    },
                    {
                        field: 'has_approved',
                        value: null
                    }
                    ,
                    {
                        field: 'has_payment_plan_created',
                        value: null
                    }
                ]

                dispatchObj.item.fields = [...dispatchObj.item.fields, ...dArr]
               

                if (itemData.start_date) { // if there is a start date allready, recalculate the end date
                    setEndDate(itemData.start_date, Number(data.data.value))
                }
            }
            
        }

        if (data.identifier.field == 'monthly_payment') { // calculate the number of months neccesarry
            if (itemData.total_balance) {
                let months = Math.ceil(itemData.total_balance / data.data.value)
                reqBody.fields.no_payments = months
                reqBody.fields.has_approved = null
                reqBody.fields.has_payment_plan_created = null

                let dArr = [
                    {
                        field: 'no_payments',
                        value: months
                    },
                    {
                        field: 'has_approved',
                        value: null
                    }
                    ,
                    {
                        field: 'has_payment_plan_created',
                        value: null
                    }
                ]
                dispatchObj.item.fields = [...dispatchObj.item.fields, ...dArr]

                if (itemData.start_date) { // if there is a start date allready, recalculate the end date
                    setEndDate(itemData.start_date, months)
                }
            }
            
        }

        if (data.identifier.field == 'start_date') { // calculate the end date month + no_payments
            reqBody.fields.has_approved = null
            reqBody.fields.has_payment_plan_created = null
            let dArr = [
                {
                    field: 'has_approved',
                    value: null
                }
                ,
                {
                    field: 'has_payment_plan_created',
                    value: null
                }
            ]
            dispatchObj.item.fields = [...dispatchObj.item.fields, ...dArr]
            setEndDate(data.data.value, itemData.no_payments)
        }


        dispatch(caseActions.modifyActiveCaseMultipleObject(dispatchObj))
        

        let update = await caseQuickUpdate(userToken, activeCase.case.id, reqBody, dispatch)

        if (update && update.errorMessage) {
            dispatch(notificationActions.setError(update))
        } else {            
        }     
    }

    let merge_before_update ={
        put_in: 'object',
        items: [
            {
                value_flag: false,
                fields_to_modify: [
                    {
                        field: 'cc_expiry_date',
                        value: null,
                    },
                    {
                        field: 'has_cc_active',
                        value: null,
                    }
                ]
            }
        ],
    
    }

    let merge_before_update_has_approved ={
        put_in: 'object',
        items: [
            {
                value_flag: false,
                fields_to_modify: [
                    {
                        field: 'has_payment_plan_created',
                        value: null
                    }
                ]
            }
        ],
    
    }

    let merge_before_update_has_payment_plan ={
        put_in: 'object',
        items: [
            {
                value_flag: false,
                fields_to_modify: [
                    {
                        field: 'has_approved',
                        value: null
                    },
                    {
                        field: 'has_payment_plan_created',
                        value: null
                    }
                ]
            }
        ],
    
    }

    return <ItemSimpleV2 data={itemData} mainItem={null} type={'case_crime_victim'} folder={'crime_victim'}>
        <div className={classes.item_inner}>
            {/* major med warning  */}
            {isCaseType(activeCase) == 'WELL' && majorMedExistsAndIsValid(activeCase) && <div className={`${classesv3.row}`}>      
                <div className={classesv3.row_inner_wrapper}>
                    <p><i className="ti ti-alert-hexagon"></i> Patient has Major Med, please check if Chiropractic is excluded</p>
                </div>      
            </div>}

            {/* CHUSA fields if case is type "WELL"  */}
            {isCaseType(activeCase) == 'WELL' && <div className={`${classesv3.row}`}>
                <div className={`${classes.grid} ${classes.grid_2} ${classes.grid_border}`}>
                    <div className={`${classes.grid} ${classes.grid_4} ${classes.grid_gap_8}`}>
                        <DefaultUpdater type={'checkbox'} value={itemData?.has_chusa} name={'has_chusa'} label={'Chusa'} identifier={{type: apiCase, field: 'has_chusa', type_id: null, folder: 'selfpay'}} extraOptions={{direction: 'reverse'}}/>                        
                        <DefaultUpdater type={'input'} value={itemData?.chusa_name_insured} name={'chusa_name_insured'} label={'Name of Insured'} identifier={{type: apiCase, field: 'chusa_name_insured', type_id: null, folder: 'selfpay'}} />
                        <DefaultUpdater type={'input'} value={itemData?.chusa_policy_number} name={'chusa_policy_number'} label={'Policy Number'} identifier={{type: apiCase, field: 'chusa_policy_number', type_id: null, folder: 'selfpay'}} />
                        <DefaultUpdater type={'date'} value={itemData?.chusa_expiry_date} label={'Expiration Date'} identifier={{type: apiCase, field: 'chusa_expiry_date', type_id: null, folder: 'selfpay'}} extraOptions={{setStyle: isDateTodayOrInThePast(itemData?.chusa_expiry_date) ? 'border_red' : ''}}/>
                    </div>
                    <div className={`${classesv3.flex}`}>
                        <FindRelatedChusaPatient />
                        <ChusaRelatedPatient items={activeCase.chusa_related_patients}/>
                    </div>
                </div>
                
            </div>}

            {/* payment plan  */}
            <div className={`${classesv3.row}`}>
                <div className={classesv3.row_inner_wrapper}>
                    <DefaultUpdater type={'checkbox'} value={itemData?.has_payment_plan} name={'has_payment_plan'} label={'Payment Plan'} identifier={{type: apiCase, field: 'has_payment_plan', type_id: null, folder: 'selfpay'}} extraOptions={{direction: 'reverse'}} merge_before_update={merge_before_update_has_payment_plan}/>
                </div>
            </div>
            {itemData?.has_payment_plan ? <div className={`${classesv3.row} ${classes.grid} ${classes.grid_border} ${classes.grid_2}`}>

                {/* payment plan fields  */}
                <div className={``}>
                    <div  className={`${classes.grid} ${classes.grid_4} ${classes.grid_gap_8}`}>
                        <SimpleBoxDisplay label={'Total Balance'} value={formatCurrency(itemData.total_balance)}/>
                        <div className={`${classes.grid} ${classes.grid_2} ${classes.grid_gap_8}`} style={{gridColumn: 'span 3'}}>
                            <InputBox action={updateHandler} currentValue={itemData?.no_payments} identifier={{type: apiCase, field: 'no_payments', type_id: null, folder: 'selfpay'}} label={'# of payments'} format={'number'}/>
                            <InputBoxCurrency action={updateHandler} label={'Monthly Payment'} currentValue={itemData?.monthly_payment} identifier={{type: apiCase, field: 'monthly_payment', type_id: null, folder: 'selfpay'}} fullBox={true}/>
                        </div>
                    </div>

                    <div  className={`${classes.grid} ${classes.grid_4} ${classes.grid_gap_8} ${classes.margin_top_8}`}>
                        <SimpleBoxDisplay label={'Enabled At'} value={formatDateLocal(itemData.enabled_at)}/>
                        <DefaultUpdater type={'select'} value={itemData?.payment_type} name={'payment_type'} label={'Payment Type'} options={frontendOptions()?.PAYMENT_TYPES_OPTIONS} identifier={{type: apiCase, field: 'payment_type', type_id: null, folder: 'selfpay'}} />
                        <DatepickerWithLabel action={updateHandler} defaultDate={itemData?.start_date} label={'Start Date'} identifier={{type: apiCase, field: 'start_date', type_id: null, folder: 'selfpay'}}/>                        
                        <DefaultUpdater type={'date'} value={itemData?.end_date} label={'Expiration Date'} identifier={{type: apiCase, field: 'end_date', type_id: null, folder: 'selfpay'}} extraOptions={{disabled: true}}/>
                    </div>                           
                    
                </div>

                {/* aprovment and phresia  */}
                <div className={classes.no_padding}>
                    {/* payment plan needs aprovment  */}
                    {(totalBalanceExceedsTheSettings(itemData.total_balance) || numberOfPaymentsExceedsTheSettings(itemData.no_payments)) ? <>
                    
                        <div className={`${classesv3.row}`}>
                            <div className={`${classesv3.row_inner_wrapper} ${classes.grid} ${classes.grid_4} ${classes.grid_gap_8}`}>                                            
                                <DefaultUpdater type={'checkbox'} value={itemData?.has_approved} name={'has_approved'} label={'Approved'} identifier={{type: apiCase, field: 'has_approved', type_id: null, folder: 'selfpay'}} extraOptions={{direction: 'reverse'}} merge_before_update={merge_before_update_has_approved}/>
                                {itemData?.has_approved ? <>
                                    <SimpleBoxDisplay label={'Approved By'} value={itemData?.approved_user?.name} maxWidth={200}/>
                                    <SimpleBoxDisplay label={'Approved at'} value={itemData?.approved_date} maxWidth={200}/>
                                </> : <p className={`${classes.error} danger`} style={{gridColumn: 'span 2'}}><i className="ti ti-alert-circle"></i> Payment plan must be approved</p>}  
                            </div>
                        </div>

                        {/* paymnet plan needs aprovment, and if it is checked, show phresia  */}
                        {itemData?.has_approved ? <div className={`${classesv3.row_inner_wrapper} ${classes.grid} ${classes.grid_4} ${classes.grid_gap_8}`}>
                            <DefaultUpdater type={'checkbox'} value={itemData?.has_payment_plan_created} name={'has_payment_plan_created'} label={'Created in Phreesia'} identifier={{type: apiCase, field: 'has_payment_plan_created', type_id: null, folder: 'selfpay'}} extraOptions={{direction: 'reverse'}}/>
                            {itemData?.has_payment_plan_created ? <>
                                <SimpleBoxDisplay label={'Approved By'} value={itemData?.payment_plan_created_user?.name} maxWidth={200}/>
                                <SimpleBoxDisplay label={'Approved at'} value={itemData?.payment_plan_created_date} maxWidth={200}/>
                            </> : ''}
                        </div>  : ''}
                    </> :

                    // payment doesn't need approvment, just needs phresia 
                        <div className={classes.row_item_full}>
                            <div className={`${classes.row} `}>
                                <DefaultUpdater type={'checkbox'} value={itemData?.has_payment_plan_created} name={'has_payment_plan_created'} label={'Created in Phreesia'} identifier={{type: apiCase, field: 'has_payment_plan_created', type_id: null, folder: 'selfpay'}} extraOptions={{direction: 'reverse'}}/>
                                {itemData?.has_payment_plan_created ? <>
                                    <SimpleBoxDisplay label={'Approved By'} value={itemData?.payment_plan_created_user?.name} maxWidth={200}/>
                                    <SimpleBoxDisplay label={'Approved at'} value={itemData?.payment_plan_created_date} maxWidth={200}/>
                                </> : ''}
                            </div>   
                        </div>
                    }    
                </div>


            </div> : ''}

            {/* payments table  */}
            <>
                {itemData?.has_payment_plan ? <div className={`${classesv3.row}`}>
                    <div className={classesv3.row_inner_wrapper}>
                        <table className="table-border-radius-8">
                            <thead>
                                <tr>
                                    <th>Practice Id</th>
                                    <th>Initial Balance</th>
                                    <th>Current Balance</th>
                                    <th>Total Paid</th>
                                    <th>Monthly Payment</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activeCase && activeCase.practices && activeCase.practices.length >0 && activeCase.practices.map(item => (
                                    <SelfPayItemPracticeV2 key={item.id} case_practice={item} self_practices={itemData.selfpay_practices} selfPay={itemData}/>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div> : ''}
            </>

            {/* credit card info  */}
            <div className={`${classesv3.row}`}>
                <div className={classesv3.row_inner_wrapper}>
                    <div className={`flex-container`}>
                        <DefaultUpdater type={'checkbox'} value={itemData?.has_cc_on_file} name={'has_cc_on_file'} label={'Credit Card on file'} identifier={{type: apiCase, field: 'has_cc_on_file', type_id: null, folder: 'selfpay'}} extraOptions={{direction: 'reverse'}} merge_before_update={merge_before_update}/>
                        {itemData?.has_cc_on_file ? <>
                            <DefaultUpdater type={'date'} value={itemData?.cc_expiry_date} label={'CC Expiration Date'} identifier={{type: apiCase, field: 'cc_expiry_date', type_id: null, folder: 'selfpay'}} extraOptions={{setStyle: isDateTodayOrInThePast(itemData?.cc_expiry_date) ? 'border_red' : ''}}/>
                            <DefaultUpdater type={'checkbox'} value={itemData?.has_cc_active ? false : true} label={'Inactive'} identifier={{type: apiCase, field: 'has_cc_active', type_id: null, folder: 'selfpay'}} extraOptions={{direction: 'reverse', reverseValueSentInAction: true}}/>
                        </> : ''}
                    </div>
                </div>
                
            </div>                 
        </div> 
    </ItemSimpleV2>
}

export default SelfPayItem